import { Head } from 'vite-react-ssg';

// Oracle Cloud Infrastructure published this customer-story video about EZ Cloud on
// Oracle's own YouTube channel (2022-06-09). All fields verified from the source video —
// do not alter name/uploadDate/publisher without re-checking the live video.
const schema = {
  '@context': 'https://schema.org',
  '@type': 'VideoObject',
  '@id': 'https://ezcloud.ai/#oracle-oci-video',
  name: 'EZ Cloud transitions to serverless for accounts payable automation',
  description:
    "Oracle Cloud Infrastructure's customer story on EZ Cloud: the AI-powered accounts payable platform runs in a Kubernetes cluster on OCI with an Autonomous Database and API Gateway, integrates with multiple ERP applications, supports concurrent users, and scales on demand at a fraction of the cost of running on VMs.",
  thumbnailUrl: 'https://i.ytimg.com/vi/4QuE_v6HBPA/hqdefault.jpg',
  uploadDate: '2022-06-09',
  contentUrl: 'https://www.youtube.com/watch?v=4QuE_v6HBPA',
  embedUrl: 'https://www.youtube.com/embed/4QuE_v6HBPA',
  publisher: {
    '@type': 'Organization',
    name: 'Oracle Cloud Infrastructure',
    url: 'https://www.youtube.com/@OracleCloudInfrastructure',
  },
  about: { '@id': 'https://ezcloud.ai/#product' },
  mainEntityOfPage: 'https://ezcloud.ai/about',
};

const VideoObjectSchema = () => (
  <Head>
    <script type="application/ld+json">{JSON.stringify(schema)}</script>
  </Head>
);

export default VideoObjectSchema;
